import { render, staticRenderFns } from "./UpgradeList.vue?vue&type=template&id=266f79de&scoped=true&"
import script from "./UpgradeList.vue?vue&type=script&lang=js&"
export * from "./UpgradeList.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeList.vue?vue&type=style&index=0&id=266f79de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f79de",
  null
  
)

export default component.exports